export const paths = {
  home: '/',
  consolidator: '/scanning',
  bags: '/manual-bags',
  sortingTapeBags: '/sorting-line-bags',
  sortingSettings: '/sorting-settings',
  shipment: '/shipment',
  manifestAcceptance: '/manifest-acceptance',
  parcels: '/parcels',
  bigs: '/bigs',
  labels: '/labels',
  labelRepair: '/labelRepair',
  wbBagsLabel: '/wb-bags-label',
  azLabel: '/az-label',
  geLabel: '/ge-label',
  parcelLabel: '/parcel-label',
  weightCheck: '/weight-check',
};
